import { render, staticRenderFns } from "./Message_Form.vue?vue&type=template&id=12662bef&"
import script from "./Message_Form.vue?vue&type=script&lang=js&"
export * from "./Message_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports